import React from 'react';
import { TFunction } from 'react-i18next';
import { withTranslation } from '@piwikpro/ui-components';
import { withInject } from '@piwikpro/platform';
import { RouterService } from '@piwikpro/router-crate';
import CreateCredentials from './CreateCredentials';
import DisplayCredentials from './DisplayCredentials';
import { ICredentialsGenerateState } from '../../../redux/credentials/generate';

export interface IGenerateCredentialsProps {
  routerService: RouterService
  client: ICredentialsGenerateState['client']
  t: TFunction
  Title: typeof React.Component
}

const GenerateCredentials: React.FC<IGenerateCredentialsProps> = ({
  client,
  Title,
  t,
  routerService,
}) => {
  const handleClose = () => {
    routerService.push({ to: '/profile/api-credentials' });
  };

  const actual = client?.id
    ? <DisplayCredentials client={client} finish={handleClose} />
    : <CreateCredentials abort={handleClose} />;

  return (
    <Title part={t('credentials.create.title')} subset>
      {actual}
    </Title>
  );
};

export default withInject({
  Title: 'TitleCrate.components.Title',
  routerService: 'RouterCrate.router',
})(withTranslation('profile')(GenerateCredentials));
